// noinspection JSDeprecatedSymbols

(function ($) {


	let initScrollAnimations = function () {
		$(window).on('scroll', function () {
			const scrollPos = $(window).scrollTop() + $(window).height();

			$('.slab').each(function (index) {
				const panelOffset = $(this).offset().top; // Trigger when the top enters the viewport

				if (scrollPos > panelOffset && !$(this).hasClass('in-view')) {
					$(this).addClass('in-view'); // Add class immediately
				}
			});
		}).trigger('scroll'); // Trigger on page load
	};
	let initAlignments = function () {
		const body = document.querySelector('body');
		const scrollbar = window.innerWidth - body.clientWidth;
		body.setAttribute("style", `--scrollbar: ${scrollbar}px`);
	};

	let initNav = function () {
		let navExposedMediaQuery = '(min-width: 60rem)';
		let siteHeader = $('#siteHeader');
		let primaryNav = $('#primaryNav');
		let siteSearch = $('#siteHeader__search');

		$('.siteHeader__button', '#siteHeader').on('click', function (e) {
			e.preventDefault();
			let isOpen = $(this).attr('aria-expanded');
			let targetID = $(this).attr('aria-controls');
			let target;

			if (targetID) {
				target = $('#' + targetID);
			}

			if (isOpen === 'true') {
				target.hide();

				$(this).attr('aria-expanded', 'false').removeClass('is-active');
			} else {
				$('.siteHeader__button').not(this).attr('aria-expanded', 'false').removeClass('is-active');
				$([primaryNav, siteSearch]).each(function () {
					$(this).hide()
				});

				if (target === 'siteNav') {
					siteHeader.addClass('has-active-nav');
				}
				target.show();

				$(this).attr('aria-expanded', 'true').addClass('is-active');

				if (targetID === 'siteHeader__search') {
					$('input[type="search"], input[type="text"]', siteSearch).focus();
				}
			}
		});

		$('#searchform').on('submit', function (e) {
			let query = $(this).find('#s').val();

			if (!query.trim()) {
				e.preventDefault();

				$(this).find('input').eq(0).focus();
			}
		});

		$('details', '#primaryNav').on('toggle', function (e) {
			let details = e.currentTarget;
			let isOpening = details.open;
			let isDesktop = window.matchMedia(navExposedMediaQuery).matches;

			if (isDesktop) {
				if (isOpening) {
					$('details', '#primaryNav').not(this).removeAttr('open');
				}

				let anyOpen = $('details[open]', '#siteNav');

				if (anyOpen.length) {
					siteHeader.addClass('has-active-nav');
				} else {
					siteHeader.removeClass('has-active-nav');
				}
			}
		});

	};

	// let initFacets = function () {
	//
	// 	let isTabletOrAbove = window.matchMedia('(min-width: 47.5rem)').matches;
	//
	// 	if (!isTabletOrAbove) {
	// 		$('#filters').removeAttr('open');
	// 	}
	//
	// 	$(document).on('facetwp-loaded', function () {
	// 		$('.facetwp-facet').each(function () {
	// 			let $facet = $(this);
	// 			let facet_name = $facet.attr('data-name');
	// 			let facet_label = FWP.settings.labels[facet_name];
	//
	// 			let excludedFacets = [
	// 				'result_count',
	// 				'load_more'
	// 			]
	//
	// 			if (!excludedFacets.includes(facet_name)) {
	// 				if (!($facet).is(':empty')) {
	// 					if ($facet.closest('.facet-wrap').length < 1 && $facet.closest('.facetwp-flyout').length < 1) {
	// 						$facet.wrap('<div class="facet-wrap"></div>');
	// 						$facet.before('<div class="facet-label">' + facet_label + '</div>');
	// 					}
	// 				}
	// 			}
	// 		});
	//
	// 		let facetCounts = $('.facetwp-counts');
	//
	// 		if (facetCounts.length) {
	// 			let topOfFilteredResults = (facetCounts.offset().top - window.innerHeight / 10);
	// 			let scrollPos = window.pageYOffset;
	//
	// 			if (scrollPos > 1) {
	// 				if (topOfFilteredResults > scrollPos + window.innerHeight / 1.5 || topOfFilteredResults < scrollPos - window.innerHeight / 10) {
	// 					$('html, body').stop().animate({
	// 						scrollTop: topOfFilteredResults
	// 					}, 250);
	// 				}
	// 			}
	// 		}
	// 	});
	// }

// --

	$(document).ready(function () {
		initNav();
		initAlignments();
		initScrollAnimations();
		// initFacets();
	});

	$(window).on('load', function () {
		// correct anything loaded on DOM load which might need adjusting (mostly once images have loaded)
	});


// $(window).smartResize(function () {
//   // events that need to fire after a window resize (or device rotation)
//   Waypoint.refreshAll();
// });

})
(jQuery);
